/* Next */
import Link from 'next/link'
import { hrefForBrandPath } from 'src/functions/navigationBreadcrumbs'

/* Material */
import Card from '@mui/material/Card'
import CardMedia from '@mui/material/CardMedia'
import useStyles from './Brands.styles'

/* Types */
import { tBrand } from 'src/shared/frontendTypes/brand'
import { CSSProperties } from 'react'

/* Options */
import config from 'src/config'

interface Props {
  brand: tBrand
}

const Brand: React.FC<Props> = ({ brand }) => {
  const classes = useStyles()

  const logo = brand.logos?.mono
  if (!logo) return null
  
  const logoPath = `${config.image_server}/brand/${logo.sm}`
  const href = hrefForBrandPath(brand.path, brand.id) || '/brands'
  
  const style: CSSProperties = {}

  logoColor: if (logo?.color?.a !== 0) {
    if (!logo?.color) break logoColor
    const { r, g, b, a } = logo.color
    style.backgroundColor = `rgba(${r}, ${g}, ${b}, ${a})`
  }

  return <div className={classes.cardColumn}>
    <Link legacyBehavior {...{href}}><a>
      <Card className={classes.card} style={style}>
        <CardMedia
          className={classes.cardMedia}
          image={logoPath}
          title={brand.titel}
        />
      </Card>
    </a></Link>
  </div>
}

export default Brand
